import YouTubePortal, { YouTubePortalProps } from './YouTubePortal';

export type { YouTubePortalProps };
export default YouTubePortal;
